import { OrganizationRole } from './types';

export const organizationRoleList = [
    OrganizationRole.Presenters,
    OrganizationRole.Participants,
    OrganizationRole.Hosts,
    OrganizationRole.Supports,
    OrganizationRole.Registrants,
];

export const roleNameMap = {
    'Presenters': OrganizationRole.Presenters,
    'Participants': OrganizationRole.Participants,
    'Hosts': OrganizationRole.Hosts,
    'Support': OrganizationRole.Supports,
    'Registrants': OrganizationRole.Registrants,
};

export type MeetingRoleConnectionField =
    'presenterRoleConnectionId'
    | 'hostRoleConnectionId'
    | 'supportRoleConnectionId';

export const meetingRoleConnectionFieldByRole: Partial<Record<OrganizationRole, MeetingRoleConnectionField>> = {
    [OrganizationRole.Presenters]: 'presenterRoleConnectionId',
    [OrganizationRole.Hosts]: 'hostRoleConnectionId',
    [OrganizationRole.Supports]: 'supportRoleConnectionId',
};

export const hasMeetingRoleConnection = (role: OrganizationRole): boolean =>
    Boolean(meetingRoleConnectionFieldByRole[role]);

export const autoSyncConnectionsLimitV1 = 1;
export const autoSyncConnectionsLimitV2 = 10;